import { Flex, Heading } from "@chakra-ui/react";
import FlagBox from "components/LanguageSwitcher/FlagBox";
import { useTranslations } from "contexts/LocalizationContext";
import { useModal } from "contexts/ModalContext";

const FOOTER_LANG_MODAL_OPEN_EVENT_UA = ["clicked", "Footer", "OpenModal"] as const;
const FOOTER_LANG_MODAL_OPEN_EVENT = { event: "cta_click", label: "open_modal", placement: "Footer" } as const;

export const Copyright = ({ hideFlagBox }: { hideFlagBox: boolean }) => {
  const translations = useTranslations();
  const { openModal } = useModal();

  return (
    <Flex
      justifyContent={hideFlagBox ? "flex-end" : "space-between"}
      alignItems="center"
      pr={{ base: 8, xl: "unset" }}
      pl={{ base: 4, xl: "unset" }}
      py={{ base: 4, xl: "unset" }}
    >
      {!hideFlagBox && (
        <FlagBox
          openModal={openModal}
          gaEvent={FOOTER_LANG_MODAL_OPEN_EVENT}
          uaEvent={FOOTER_LANG_MODAL_OPEN_EVENT_UA}
        />
      )}
      <Heading as="h4" color="greyscale.500" fontWeight="normal" fontSize="sm">
        {translations("menu_copyright", { "%current-year%": new Date().getFullYear() })}
      </Heading>
    </Flex>
  );
};
